import React from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { Roles } from "../../roles";
import Loading from "../Loading";
export default function RedirectIfAuthenticated() {
    const { isAuthenticated, loading, user } = useAuth(); // assuming userData has role & username
    const { lang } = useParams();

    if (loading) {
        return <Loading />; // Your loading spinner
    }

    if (isAuthenticated) {
        if (user?.role === Roles.USER) {
            return (
                <Navigate
                    to={`/lang/${lang}/files/${user?.userName}`}
                    replace
                    state={{ data: user }}
                />
            );
        }

        if (user?.role === Roles.ADMIN || user?.role === Roles.SUPERADMIN) {
            return (
                <Navigate
                    to={`/lang/${lang}/admin/dashboard`}
                    replace
                    state={{ data: user }}
                />
            );
        }
    }


    return <Outlet />;
}
